import { wrapFetch } from '../libs/fetch';
import { BillingInfo, FetchCurrentNextPlanInfo, FetchIsCancelled, FetchCancelledContents, FetchPlanOptions, PostPlanReservation, PostUpdateBillingInfo } from '../types/companyAccount';

export const fetchCurrentNextPlanInfo = async (nextTrial?: boolean) => {
  const query = nextTrial ? '?next_trial=true' : '';
  return await wrapFetch<FetchCurrentNextPlanInfo>(`/api/v1/plan/get_current_next_plan_info${query}`);
};

export const fetchPlanOptions = async () => {
  return await wrapFetch<FetchPlanOptions>('/api/v1/plan/get_plan_options');
};

export const postPlanReservation = async (body: string, csrfToken: string) => {
  return await wrapFetch<PostPlanReservation>('/api/v1/plan/plan_reservation', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const fetchBillingInfo = async () => {
  return await wrapFetch<BillingInfo>('/api/v1/plan/get_billing_info');
};

export const updateBillingInfo = async (body: string, csrfToken: string) => {
  return await wrapFetch<PostUpdateBillingInfo>('/api/v1/plan/update_billing_info', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const cancelPlan = async (body: string, csrfToken: string) => {
  return await wrapFetch<PostUpdateBillingInfo>('/api/v1/plan/cancel_plan', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const fetchIsCancelled = async () => {
  return await wrapFetch<FetchIsCancelled>('/api/v1/plan/is_cancelled');
};

export const fetchCancelledContents = async () => {
  return await wrapFetch<FetchCancelledContents>('/api/v1/plan/fetch_cancelled_contents');
};
